export default __webpack_public_path__ + "static/media/SndLowerBSwimUpOver.c8d5ac76.mp3";